'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleProptype = require('react-style-proptype');

var _reactStyleProptype2 = _interopRequireDefault(_reactStyleProptype);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var isTextTruthy = function isTextTruthy(val) {
  return val !== undefined && val !== null && val.toString() !== '';
};

var TextField = function (_Component) {
  _inherits(TextField, _Component);

  function TextField() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TextField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextField.__proto__ || Object.getPrototypeOf(TextField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      float: false,
      hasFocus: false
    }, _this.focus = function () {
      if (_this.ref) {
        _this.ref.focus();
      }
    }, _this.handleBlur = function (e) {
      _this.setState({
        hasFocus: false
      }, function () {
        return _this.handleShouldFloat(_this.props.value);
      });

      _this.props.onBlur && _this.props.onBlur(e);
    }, _this.handleFocus = function (e) {
      _this.setState({
        hasFocus: true,
        float: true
      });

      _this.props.onFocus && _this.props.onFocus(e);
    }, _this.handleShouldFloat = function (value) {
      _this.setState(function (prevState) {
        var float = prevState.hasFocus || isTextTruthy(value);
        return {
          float: float
        };
      });
    }, _this.handleRef = function (ref) {
      _this.ref = ref;

      _this.props.inputRef(ref);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TextField, [{
    key: 'UNSAFE_componentWillMount',
    value: function UNSAFE_componentWillMount() {
      // eslint-disable-line camelcase
      this.handleShouldFloat(this.props.value); // build a unique ID for this field in case one was not provided
      // logic from https://github.com/callemall/material-ui/blob/master/src/TextField/TextField.js

      var uniqueId = this.props.name + '-' + this.props.placeholder + '-' + this.props.label + '-' + Math.floor(Math.random() * 0xffff);
      this.uniqueId = uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
    }
  }, {
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(props) {
      // eslint-disable-line camelcase
      this.handleShouldFloat(props.value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          type = _props.type,
          value = _props.value,
          label = _props.label,
          placeholder = _props.placeholder,
          helpText = _props.helpText,
          id = _props.id,
          required = _props.required,
          disabled = _props.disabled,
          autoFocus = _props.autoFocus,
          bsStyle = _props.bsStyle,
          className = _props.className,
          onChange = _props.onChange,
          onClick = _props.onClick,
          onKeyDown = _props.onKeyDown,
          style = _props.style,
          inputStyle = _props.inputStyle,
          rightAddon = _props.rightAddon,
          inputRef = _props.inputRef,
          rest = _objectWithoutProperties(_props, ['name', 'type', 'value', 'label', 'placeholder', 'helpText', 'id', 'required', 'disabled', 'autoFocus', 'bsStyle', 'className', 'onChange', 'onClick', 'onKeyDown', 'style', 'inputStyle', 'rightAddon', 'inputRef']);

      var inputId = id || this.uniqueId;
      var isTextArea = type === 'textarea';
      var wrapperClassNames = ['form-group', className];
      label && this.state.float && wrapperClassNames.push('form-group-active');
      required && wrapperClassNames.push('required');
      bsStyle && wrapperClassNames.push('has-' + bsStyle);
      disabled && wrapperClassNames.push('disabled');

      var inputProps = _extends({}, rest, {
        className: 'form-control',
        style: inputStyle,
        name: name,
        value: value,
        placeholder: placeholder,
        id: inputId,
        required: required,
        disabled: disabled,
        autoFocus: autoFocus,
        onChange: onChange,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        ref: this.handleRef
      });

      if (!isTextArea) {
        inputProps.type = type;
      }

      var inputElement = isTextArea ? _react2.default.createElement('textarea', inputProps) : _react2.default.createElement('input', inputProps);
      var labelElement = label ? _react2.default.createElement('label', {
        className: 'control-label' + (isTextArea ? ' textarea-label' : ''),
        htmlFor: inputId
      }, label) : null;
      return _react2.default.createElement('div', {
        className: wrapperClassNames.join(' '),
        style: style
      }, rightAddon ? _react2.default.createElement('div', {
        className: 'input-group'
      }, inputElement, labelElement, _react2.default.createElement('span', {
        className: 'input-group-btn'
      }, rightAddon)) : _react2.default.createElement(_react.Fragment, null, inputElement, labelElement), helpText ? _react2.default.createElement('small', {
        className: 'help-block'
      }, helpText) : null);
    }
  }]);

  return TextField;
}(_react.Component);

exports.default = TextField;
TextField.propTypes = {
  name: _propTypes2.default.string,
  type: _propTypes2.default.oneOf(['text', 'number', 'password', 'url', 'search', 'email', 'tel', 'textarea']),
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  label: _propTypes2.default.node,
  placeholder: _propTypes2.default.string,
  helpText: _propTypes2.default.node,
  id: _propTypes2.default.string,
  required: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  autoFocus: _propTypes2.default.bool,
  bsStyle: _propTypes2.default.oneOf(['success', 'warning', 'error', '']),
  className: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  style: _reactStyleProptype2.default,
  inputStyle: _reactStyleProptype2.default,
  rightAddon: _propTypes2.default.element,
  inputRef: _propTypes2.default.func
};
TextField.defaultProps = {
  autoFocus: false,
  required: false,
  disabled: false,
  className: '',
  type: 'text',
  value: '',
  inputRef: function inputRef() {}
};